(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-category-finder"]) return;
  try {
    
(() => {
const initCategoryFinder = (section) => {
if (!section || section.dataset.categoryFinderInitialized === 'true') return;
const toggle = section.querySelector('[data-category-finder-toggle]');
if (!toggle) return;
section.dataset.categoryFinderInitialized = 'true';
toggle.addEventListener('click', () => {
const isExpanded = section.dataset.expanded === 'true';
const nextExpanded = !isExpanded;
const collapsedLabel = toggle.dataset.collapsedLabel || 'Show all categories';
const expandedLabel = toggle.dataset.expandedLabel || 'Show less';
section.dataset.expanded = nextExpanded ? 'true' : 'false';
toggle.textContent = nextExpanded ? expandedLabel : collapsedLabel;
toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
});
};
const initAllCategoryFinders = (root = document) => {
root.querySelectorAll('[data-category-finder]').forEach(initCategoryFinder);
};
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initAllCategoryFinders());
} else {
initAllCategoryFinders();
}
document.addEventListener('shopify:section:load', (event) => {
initAllCategoryFinders(event.target);
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-main-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
    const quickAnswer = document.querySelector('.st-guide-answer__text');
    const content = document.querySelector('[data-guide-main-content]');

    if (!quickAnswer || !content) return;

    const quickAnswerText = normalizeText(quickAnswer.textContent || '');
    const contentBlocks = Array.from(content.children).filter((element) => normalizeText(element.textContent || '').length > 0);
    const firstBlock = contentBlocks[0];

    if (!quickAnswerText || !firstBlock) return;

    const isDuplicateOfQuickAnswer = (element) => {
      const elementText = normalizeText(element.textContent || '');
      const shorterLength = Math.min(quickAnswerText.length, elementText.length);
      const longerLength = Math.max(quickAnswerText.length, elementText.length);
      const lengthRatio = longerLength === 0 ? 0 : shorterLength / longerLength;

      return (
        elementText === quickAnswerText ||
        (lengthRatio > 0.85 && (elementText.includes(quickAnswerText) || quickAnswerText.includes(elementText)))
      );
    };

    if (isDuplicateOfQuickAnswer(firstBlock)) {
      firstBlock.remove();
      return;
    }

    if (/^h[2-3]$/i.test(firstBlock.tagName)) {
      const nextBlock = firstBlock.nextElementSibling;

      if (nextBlock && isDuplicateOfQuickAnswer(nextBlock)) {
        firstBlock.remove();
        nextBlock.remove();
      }
    }
  })();

  (() => {
    const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
    const content = document.querySelector('[data-guide-main-content]');
    const faqSection = document.querySelector('[data-guide-faq-section]');

    if (!content || !faqSection) return;

    const commonQuestionsHeading = Array.from(content.querySelectorAll('h2')).find((heading) => {
      return normalizeText(heading.textContent || '') === 'common questions';
    });

    if (!commonQuestionsHeading) return;

    const questionList = commonQuestionsHeading.nextElementSibling;

    if (questionList && /^[uo]l$/i.test(questionList.tagName)) {
      questionList.remove();
      commonQuestionsHeading.remove();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-prototype"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildSchemaFaq = (content) => {
      content.querySelectorAll('[itemscope][itemtype*="FAQPage"]').forEach((faqBlock) => {
        if (faqBlock.dataset.accordionReady === 'true') {
          return;
        }

        faqBlock.dataset.accordionReady = 'true';
        faqBlock.classList.add('st-blog-faq');

        faqBlock.querySelectorAll('[itemscope][itemprop="mainEntity"]').forEach((item) => {
          if (item.matches('details')) {
            return;
          }

          const question = item.querySelector('[itemprop="name"]');
          const answer = item.querySelector('[itemprop="acceptedAnswer"]');

          if (!question || !answer) {
            return;
          }

          const details = document.createElement('details');
          details.className = 'st-blog-faq__item';
          details.setAttribute('itemscope', '');
          details.setAttribute('itemprop', 'mainEntity');
          details.setAttribute('itemtype', 'https://schema.org/Question');

          const summary = document.createElement('summary');
          summary.className = 'st-blog-faq__question';
          summary.setAttribute('itemprop', 'name');
          summary.innerHTML = question.innerHTML;

          answer.classList.add('st-blog-faq__answer');
          details.appendChild(summary);
          details.appendChild(answer);
          item.replaceWith(details);
        });
      });
    };

    const buildFallbackFaq = (content) => {
      const faqHeading = Array.from(content.querySelectorAll('h2')).find((heading) =>
        heading.textContent.trim().toLowerCase().includes('frequently asked questions')
      );

      if (!faqHeading || faqHeading.dataset.accordionReady === 'true') {
        return;
      }

      const nextElement = faqHeading.nextElementSibling;

      if (!nextElement || nextElement.classList.contains('st-blog-faq') || nextElement.matches('[itemscope][itemtype*="FAQPage"]')) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'st-blog-faq';
      faqHeading.dataset.accordionReady = 'true';
      faqHeading.insertAdjacentElement('afterend', wrapper);

      let current = wrapper.nextSibling;

      while (current) {
        if (current.nodeType === Node.ELEMENT_NODE && current.matches('h2')) {
          break;
        }

        const next = current.nextSibling;

        if (current.nodeType === Node.ELEMENT_NODE && current.matches('h3')) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const answer = document.createElement('div');

          details.className = 'st-blog-faq__item';
          summary.className = 'st-blog-faq__question';
          answer.className = 'st-blog-faq__answer';
          summary.innerHTML = current.innerHTML;

          details.appendChild(summary);
          current.remove();

          let answerNode = next;

          while (answerNode) {
            if (answerNode.nodeType === Node.ELEMENT_NODE && (answerNode.matches('h2') || answerNode.matches('h3'))) {
              break;
            }

            const following = answerNode.nextSibling;
            answer.appendChild(answerNode);
            answerNode = following;
          }

          details.appendChild(answer);
          wrapper.appendChild(details);
          current = answerNode;
          continue;
        }

        if (current.nodeType === Node.TEXT_NODE && current.textContent.trim() === '') {
          current.remove();
        }

        current = next;
      }

      if (!wrapper.querySelector('details')) {
        wrapper.remove();
      }
    };

    const initBlogFaqAccordions = () => {
      document.querySelectorAll('.st-blog-content').forEach((content) => {
        buildSchemaFaq(content);
        buildFallbackFaq(content);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBlogFaqAccordions);
    } else {
      initBlogFaqAccordions();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
    const quickAnswer = document.querySelector('.st-guide-answer__text');
    const content = document.querySelector('.st-guide-content');

    if (!quickAnswer || !content) return;

    const quickAnswerText = normalizeText(quickAnswer.textContent || '');
    const contentBlocks = Array.from(content.children).filter((element) => normalizeText(element.textContent || '').length > 0);
    const firstBlock = contentBlocks[0];

    if (!quickAnswerText || !firstBlock) return;

    const isDuplicateOfQuickAnswer = (element) => {
      const elementText = normalizeText(element.textContent || '');
      const shorterLength = Math.min(quickAnswerText.length, elementText.length);
      const longerLength = Math.max(quickAnswerText.length, elementText.length);
      const lengthRatio = longerLength === 0 ? 0 : shorterLength / longerLength;

      return (
        elementText === quickAnswerText ||
        (lengthRatio > 0.85 && (elementText.includes(quickAnswerText) || quickAnswerText.includes(elementText)))
      );
    };

    if (isDuplicateOfQuickAnswer(firstBlock)) {
      firstBlock.remove();
      return;
    }

    if (/^h[2-3]$/i.test(firstBlock.tagName)) {
      const nextBlock = firstBlock.nextElementSibling;

      if (nextBlock && isDuplicateOfQuickAnswer(nextBlock)) {
        firstBlock.remove();
        nextBlock.remove();
      }
    }
  })();

  (() => {
    const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
    const content = document.querySelector('.st-guide-content');
    const faqSection = document.querySelector('[data-guide-faq-section]');

    if (!content || !faqSection) return;

    const commonQuestionsHeading = Array.from(content.querySelectorAll('h2')).find((heading) => {
      return normalizeText(heading.textContent || '') === 'common questions';
    });

    if (!commonQuestionsHeading) return;

    const questionList = commonQuestionsHeading.nextElementSibling;
    const answeredItems = Array.from(faqSection.querySelectorAll('.st-guide-faq__item'));

    if (!questionList || !/^[uo]l$/i.test(questionList.tagName) || answeredItems.length === 0) return;

    const accordion = document.createElement('div');
    accordion.className = 'st-guide-faq__list st-guide-faq__list--inline';
    answeredItems.forEach((item) => accordion.appendChild(item.cloneNode(true)));
    questionList.replaceWith(accordion);
    faqSection.remove();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-helpful-guides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const guideSections = document.querySelectorAll('.pp-guides[data-mobile-reveal="true"]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (guideSections.length && isMobile && !prefersReducedMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      guideSections.forEach((section) => {
        section.querySelectorAll('.pp-guides__card').forEach((card) => observer.observe(card));
      });
    } else {
      guideSections.forEach((section) => {
        section.querySelectorAll('.pp-guides__card').forEach((card) => card.classList.add('is-visible'));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storiginator-crafts"] && !Shopify.designMode) return;
  try {
    
  class DeferredBackground extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || this.observer) return;

      if (!('IntersectionObserver' in window)) {
        this.loadImage();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.loadImage();
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.disconnectObserver();
    }

    loadImage() {
      if (this.dataset.loaded === 'true') return;

      for (const source of this.querySelectorAll('source[data-srcset]')) {
        source.srcset = source.dataset.srcset || '';
        source.removeAttribute('data-srcset');
      }

      for (const image of this.querySelectorAll('img[data-src], img[data-srcset]')) {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      }

      this.dataset.loaded = 'true';
      this.disconnectObserver();
    }

    disconnectObserver() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  if (!customElements.get('deferred-background')) {
    customElements.define('deferred-background', DeferredBackground);
  }

  } catch(e) { console.error(e); }
})();
})();
